<template>

  <div style="min-height: 200px;max-height: 400px;overflow: auto">

    <el-table
      :data="appVersionList"
      stripe
      show-overflow-tootip="true"
    >

      <el-table-column  align="center" v-for="item in this.projectConfig.APP_VERSION_LIST_HEADER" :prop="item.prop" :label="item.label"
                       :key="item.prop">

      </el-table-column>


      <el-table-column
        label="操作"
      >
        <template slot-scope="scope">
          <el-button type="text" size="small" @click.native.prevent="deleteAppVersion(scope.$index, appVersionList)">删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

  </div>

</template>

<script>

  import { handleResponse } from '../../utils/response'
  import { deleteAppVersion, getAppVersionList } from '../../api/appManageApi'

  export default {
    name: 'AppVersionList',
    props: {
      appId: {
        type: Number,
        default: -1
      }
    },
    mounted () {

      this.getAppVersionListByAppId(this.appId)
    },
    created () {
      console.log('-------------ota列表界面 created-------------')
    },

    watch: {
      appId (newValue, oldValue) {

        this.getAppVersionListByAppId(newValue)
      }
    },
    methods: {


      deleteAppVersion (index, rows) {
        let id = this.appVersionList[index]['id']

        this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          deleteAppVersion(id).then(response => {
              handleResponse(response, data => {
                  this.getAppVersionListByAppId(this.appId)
                },
                error => {

                }
              )
            }
          )

          // this.$message({
          //   type: 'success',
          //   message: '删除成功!'
          // });
        }).catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // });
        });




      },
      getAppVersionListByAppId (e) {
        getAppVersionList(e).then(response => {
            handleResponse(response, data => {
                console.log(data)
                this.appVersionList = data.list
              },
              error => {
              }
            )
          }
        )
      }
    },
    data () {
      return {
        appVersionList: []
      }
    }
  }
</script>

<style scoped>

</style>
